// src/components/Profile/ProfileForm.js
import React, { useState } from 'react'
import {
  Typography,
  Grid,
  TextField,
  Button,
  CircularProgress
} from '@mui/material'
import { doc, updateDoc } from 'firebase/firestore'
import { db } from '../../firebase'
import { getAuth } from 'firebase/auth'

// Çoklu dil desteği
import { useTranslation } from 'react-i18next'

/**
 * onProfileSave: Profil başarıyla güncellenince çağrılacak callback (Profile.js'ten geliyor).
 */
export default function ProfileForm({ userData, setError, setSuccess, onProfileSave }) {
  const { t } = useTranslation()  // i18n Hook
  const auth = getAuth()

  const [firstName, setFirstName] = useState(userData.firstName || '')
  const [lastName, setLastName] = useState(userData.lastName || '')
  const [nickname, setNickname] = useState(userData.nickname || '')
  const [phone, setPhone] = useState(userData.phone || '')
  const [updating, setUpdating] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setUpdating(true)
    setError('')
    setSuccess('')

    try {
      const uid = (userData && userData.uid) || auth.currentUser?.uid
      if (!uid) {
        throw new Error('Missing user UID')
      }
      const userDocRef = doc(db, 'users', uid)
      const updateData = {
        firstName,
        lastName,
        nickname,
        phone: phone.trim() === '' ? null : phone
      }
      // Firestore'da profil bilgisini güncelle
      await updateDoc(userDocRef, updateData)

      setSuccess(t('profileForm.updateSuccess')) // "Profiliniz başarıyla güncellendi!"

      // Form güncellemesi başarılı -> Profile.js'ten gelen callback çalıştır
      if (onProfileSave) {
        onProfileSave()
      }
    } catch (err) {
      console.error('Profil güncellenirken hata:', err)
      setError(t('profileForm.updateError')) // "Profil güncellenirken bir hata oluştu."
    } finally {
      setUpdating(false)
    }
  }

  return (
    <form onSubmit={handleSubmit}>
      <Typography variant="h5" gutterBottom>
        {t('profileForm.title')}
      </Typography>
      <Grid container spacing={2}>
        {/* E-posta (readonly) */}
        <Grid item xs={12}>
          <TextField
            fullWidth
            label={t('profileForm.emailLabel')}
            variant="outlined"
            value={userData.email}
            disabled
          />
        </Grid>

        {/* Nickname */}
        <Grid item xs={12}>
          <TextField
            fullWidth
            label={t('profileForm.nicknameLabel')}
            variant="outlined"
            value={nickname}
            onChange={(e) => setNickname(e.target.value)}
            placeholder={t('profileForm.nicknamePlaceholder')}
          />
        </Grid>

        {/* İsim / Soyisim */}
        <Grid item xs={12} sm={6}>
          <TextField
            required
            fullWidth
            label={t('profileForm.firstNameLabel')}
            variant="outlined"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            required
            fullWidth
            label={t('profileForm.lastNameLabel')}
            variant="outlined"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
          />
        </Grid>

        {/* Telefon Numarası */}
        <Grid item xs={12}>
          <TextField
            fullWidth
            label={t('profileForm.phoneLabel')}
            variant="outlined"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            placeholder={t('profileForm.phonePlaceholder')}
          />
        </Grid>
      </Grid>

      <Button
        type="submit"
        variant="contained"
        color="primary"
        fullWidth
        sx={{ mt: 4, py: 1.5 }}
        disabled={updating}
      >
        {updating ? <CircularProgress size={24} color="inherit" /> : t('profileForm.submitButton')}
      </Button>
    </form>
  )
}